const initialState = {
  activeTab: 'branches',
  branches: {
    items: [],
    isLoading: true,
    error: null,
  },
  teams: {
    items: [],
    isLoading: true,
    error: null,
  },
  teamCreation: {
    isLoading: false,
    error: null,
  },
  branchCreation: {
    isLoading: false,
    error: null,
  },
  branchEdit: {
    isLoading: false,
    error: null,
  },
  branchDetail: {
    data: null,
    requestedId: null,
    isLoading: true,
    error: null,
  },
  branchDeletion: {
    isLoading: false,
    error: null,
  },
  teamDeletion: {
    isLoading: false,
    error: null,
  },
  teamEdit: {
    isLoading: false,
    error: null,
  },
  teamDetail: {
    data: null,
    requestedId: null,
    isLoading: true,
    error: null,
  },
  permissionGroups: {
    items: [],
    isLoading: true,
    error: null,
  },
  agentsSearch: {
    query: '',
    items: [],
    isLoading: false,
    error: null,
  },
  branchMembers: {
    branchId: null,
    items: [],
    isLoading: true,
    error: null,
  },
  teamMembers: {
    teamId: null,
    items: [],
    isLoading: true,
    error: null,
  },
};

export default initialState;
